import Vue from 'vue'

export const Resources = Vue.component('resources-index', require('./index.vue'));
export const ResourcesPanel = Vue.component('resources-panel', require('./ResourcesPanel.vue'));
export const ResourceCard = Vue.component('resource-card', require('./ResourceCard.vue'));


// WEBPACK FOOTER //
// ./resources/assets/js/views/resources/index.js